module.exports = __webpack_public_path__ + "img/icon_home_yw02.bdf5a51d.png";